import React from "react";
import { Client } from "@/lib/types/database";

interface ClientAddressInfoProps {
  client: Client;
  variant?: "default" | "compact";
  showTitle?: boolean;
}

export const ClientAddressInfo: React.FC<ClientAddressInfoProps> = ({
  client,
  variant = "default",
  showTitle = true,
}) => {
  const isCompact = variant === "compact";

  const content = (
    <div className={isCompact ? "space-y-1" : "space-y-3"}>
      {client.address && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "Street" : "Street"}
          </p>
          <p className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground`}>
            {client.address}
          </p>
        </div>
      )}
      {client.city && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "City" : "City"}
          </p>
          <p className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground`}>
            {client.city}
          </p>
        </div>
      )}
      {client.state && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "State" : "State"}
          </p>
          <p className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground`}>
            {client.state}
          </p>
        </div>
      )}
      {client.zip_code && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "ZIP" : "ZIP Code"}
          </p>
          <p className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground`}>
            {client.zip_code}
          </p>
        </div>
      )}
      {client.country && (
        <div>
          <p className={`${isCompact ? "text-xs" : "text-sm"} font-medium text-gray-500`}>
            {isCompact ? "Country" : "Country"}
          </p>
          <p className={`${isCompact ? "text-sm" : "text-base"} text-card-foreground`}>
            {client.country}
          </p>
        </div>
      )}
    </div>
  );

  if (!showTitle) {
    return content;
  }

  return (
    <div>
      <h2 className={`${isCompact ? "text-sm" : "text-lg"} font-semibold mb-4`}>
        {isCompact ? "Address" : "Address"}
      </h2>
      {content}
    </div>
  );
};
